/**
 * Alberath Game Name Generator
 *
 * Generates dramatic medieval/historical game names
 * Format: "${prefix} ${adjective} ${noun}" or "${prefix} ${noun}"
 * Examples: "The Crimson Campaign", "War of the Iron Crown", "Siege of Shadow Keep"
 */

const prefixes = ['The', 'War of', 'War of the', 'Battle of', 'Battle of the', 'Siege of', 'Fall of', 'Fall of the', 'Rise of', 'Rise of the'];
const adjectives = ['Crimson', 'Dark', 'Iron', 'Golden', 'Shadow', 'Ancient', 'Fallen', 'Silver', 'Blood', 'Steel', 'Eternal', 'Lost'];
const nouns = ['Campaign', 'Crown', 'Throne', 'Banner', 'Keep', 'Kingdom', 'Legion', 'Crusade', 'Empire', 'Blade', 'Sword', 'Shield'];

/**
 * Generates a random dramatic medieval game name
 * @returns {string} A random game name like "The Crimson Campaign" or "War of the Iron Crown"
 */
export function generateGameName() {
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];

  // 50% chance to include an adjective
  const useAdjective = Math.random() > 0.5;

  if (useAdjective) {
    const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    return `${prefix} ${adjective} ${noun}`;
  } else {
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    return `${prefix} ${noun}`;
  }
}
